var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSetupSmall = function SvgSetupSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "202px",
    height: "121px",
    viewBox: "0 0 202 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "setup_small")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salesforce-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration_small_setup",
    transform: "translate(-54.000000, -41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Empty-State-/-z-nested-/-Setup-/-Small"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Setup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 300,
    height: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cloud1",
    transform: "translate(62.000000, 75.748815)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud1LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8.79146919 L31.5,8.79146919 C31.1394857,6.06480614 32.0407715,3.78378292 34.2038574,1.94839955 C36.6877441,-0.0982417247 39.6367188,0.360587604 41.220459,1.06679965 C42.8041992,1.7730117 43.9803467,2.74328671 44.7956543,4.5741966 C45.1411133,5.34508018 45.3758952,5.99728321 45.5,6.53080569",
    id: "Cloud1LightBlueLine4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,10.2985782 C42.0279134,8.46301559 43.1113688,7.26289664 44.7503662,6.69822136 C47.2088623,5.85120844 49.5400391,6.97920986 50.4711914,8.11420227 C51.4023438,9.24919468 51.6975098,10.1609662 51.873291,11.1124759 C51.9904785,11.7468158 52.0327148,12.4802559 52,13.3127962 L54.081543,13.3127962 C56.0183919,13.8295019 56.9937985,14.9811653 57.0077626,16.7677864 C57.0322678,19.9575033 54.6954577,20.7511848 53.5,20.7511848 L14,20.7511848",
    id: "Cloud1LightBlueLine3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14.7511848,
    x2: 41.5002493,
    y2: 14.7511848,
    id: "Cloud1LightBlueLine2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 14.7511848,
    x2: 4,
    y2: 14.7511848,
    id: "Cloud1LightBlueLine1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud2",
    transform: "translate(170.000000, 52.748815)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud2LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8.79146919 L31.5,8.79146919 C31.1394857,6.06480614 32.0407715,3.78378292 34.2038574,1.94839955 C36.6877441,-0.0982417247 39.6367188,0.360587604 41.220459,1.06679965 C42.8041992,1.7730117 43.9803467,2.74328671 44.7956543,4.5741966 C45.1411133,5.34508018 45.3758952,5.99728321 45.5,6.53080569",
    id: "Cloud2LightBlueLine4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,10.2985782 C42.0279134,8.46301559 43.1113688,7.26289664 44.7503662,6.69822136 C47.2088623,5.85120844 49.5400391,6.97920986 50.4711914,8.11420227 C51.4023438,9.24919468 51.6975098,10.1609662 51.873291,11.1124759 C51.9904785,11.7468158 52.0327148,12.4802559 52,13.3127962 L54.081543,13.3127962 C56.0183919,13.8295019 56.9937985,14.9811653 57.0077626,16.7677864 C57.0322678,19.9575033 54.6954577,20.7511848 53.5,20.7511848 L14,20.7511848",
    id: "Cloud2LightBlueLine3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14.7511848,
    x2: 41.5002493,
    y2: 14.7511848,
    id: "Cloud2LightBlueLine2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 14.7511848,
    x2: 4,
    y2: 14.7511848,
    id: "Cloud2LightBlueLine1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bush1",
    transform: "translate(75.500000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.169884, 0.137630)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bush1LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4810708,13.2322245 C69.1128675,10.0071547 65.9723882,7.7514553 62.316946,7.7514553 C61.3098316,7.7514553 60.3418061,7.92267707 59.4391638,8.23821958 C57.7257405,5.58521329 54.783703,3.83492723 51.4418946,3.83492723 C48.2456337,3.83492723 45.4150793,5.43607116 43.6754255,7.89678339 C42.9794978,7.4840805 42.1711578,7.24781705 41.3088803,7.24781705 C40.5541571,7.24781705 39.8407551,7.42881672 39.2078836,7.75070193 C37.4987664,3.29361107 33.2549152,0.137629938 28.2902279,0.137629938 C23.7316418,0.137629938 19.7807891,2.79842183 17.8418652,6.68409115 C16.6956017,6.13348651 15.4157432,5.82577963 14.0656371,5.82577963 C9.71867522,5.82577963 6.09994221,9.01564989 5.32381071,13.2322245 L70.4810708,13.2322245 L70.4810708,13.2322245 Z",
    id: "Bush1LightBlueShape",
    fill: "#C2E8FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12.5,
    x2: 65,
    y2: 12.5,
    id: "Bush1LightBlueLine",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bush2",
    transform: "translate(166.000000, 140.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bush2LightBlue",
    transform: "translate(0.146718, 0.027273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7143538,20.9727273 L0.0497716281,20.9727273 C0.0168307478,20.6044744 0,20.2315035 0,19.8545455 C0,13.10663 5.39332657,7.63636364 12.046332,7.63636364 C13.8746008,7.63636364 15.6077425,8.04946135 17.1599751,8.78864886 C19.7856014,3.57212308 25.135714,0 31.3087987,0 C38.0318128,0 43.7786947,4.23691726 46.0931242,10.2205795 C46.9501377,9.78844733 47.916203,9.54545455 48.9382239,9.54545455 C50.1058914,9.54545455 51.2005184,9.86263918 52.1429206,10.4166944 C54.4987017,7.11317846 58.3317442,4.96363636 62.6600141,4.96363636 C69.0217205,4.96363636 74.313576,9.60734023 75.4173776,15.7335706 C75.7436941,15.6815523 76.078197,15.6545455 76.4189189,15.6545455 C79.5585481,15.6545455 82.170119,17.9476849 82.7143538,20.9727273 L82.7143538,20.9727273 Z",
    id: "Bush2LightBlueShape",
    fill: "#C2E8FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3532819,
    y1: 20.2227273,
    x2: 86.8532819,
    y2: 20.2227273,
    id: "Bush2LightBlueLine",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CompassBack",
    transform: "translate(56.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CompassBackLightBlue",
    transform: "translate(55.000000, 14.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "NetOutlineBkgd",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    x: 40,
    y: 10,
    width: 7,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "TopPartBkgd",
    x: 36,
    y: 0,
    width: 15,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "OuterCircleBkgd",
    cx: 43.5,
    cy: 60,
    r: 43.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "CompassBackWhtie",
    transform: "translate(58.000000, 15.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "InnerCircleBkgd",
    cx: 40.5,
    cy: 58.5,
    r: 36.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "TopPartHighlight",
    x: 33.5,
    y: 0.5,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0900878906,45.1135254 C0.389404297,44.7558594 5.68334961,32.1235352 15.2021484,26.1044922 C24.7209473,20.0854492 32.1862793,17.604248 42.5820313,18.1699219 C52.9777832,18.7355957 61.1525879,22.4484863 66.7438965,26.8916016 C72.3352051,31.3347168 78.4553223,38.8918457 81.640625,46.8908691 C83.7641602,52.2235514 82.3392741,48.4888509 77.3659668,35.6867676 L67.2807617,25.1953125 L53.2119141,17.9157715 L41.7807617,16.1923828 L30.706543,17.060791 L20.371582,20.793457 L10.6259766,27.298584 L3.45410156,36.5317383 C1.01188151,42.4913737 -0.10945638,45.3519694 0.0900878906,45.1135254 Z",
    id: "OuterCircleHightlight"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CompassBackDarkBlue",
    stroke: "#8CD3F8",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.5,21.3680564 C88.7566125,19.1688749 87,15.7895769 87,12 C87,5.372583 92.372583,0 99,0 C105.627417,0 111,5.372583 111,12 C111,16.2320111 108.809274,19.9523507 105.5,22.0888395 L105.5,15.5 C105.5,14.9477153 105.052285,14.5 104.5,14.5 L92.5,14.5 C91.9477153,14.5 91.5,14.9477153 91.5,15.5 L91.5,21.3680564 L91.5,21.3680564 Z",
    id: "TopRing",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5,14.5 L104.5,14.5 C105.052285,14.5 105.5,14.9477153 105.5,15.5 L105.5,24.5 C105.5,25.0522847 105.052285,25.5 104.5,25.5 L92.5,25.5 C91.9477153,25.5 91.5,25.0522847 91.5,24.5 L91.5,15.5 C91.5,14.9477153 91.9477153,14.5 92.5,14.5 Z",
    id: "Top",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5,25.5 L102.5,25.5 L102.5,30.5 C101.190239,30.3809524 99.8648157,30.3214286 98.5237305,30.3214286 C97.1826452,30.3214286 95.8414017,30.3809524 94.5,30.5 L94.5,25.5 Z",
    id: "NeckOutline"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 117.5,
    x2: 198,
    y2: 117.5,
    id: "HorizonLine2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 117.5,
    x2: 10,
    y2: 117.5,
    id: "HorizonLine1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "OuterCircle",
    cx: 98.5,
    cy: 74,
    r: 43.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "InnerCircle",
    cx: 98.5,
    cy: 74,
    r: 36.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CompassFront",
    transform: "translate(126.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CompassLightBlue",
    transform: "translate(1.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval1",
    stroke: "#C2E8FF",
    strokeWidth: 6,
    cx: 27.5,
    cy: 27.5,
    r: 20.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle4",
    fill: "#C2E8FF",
    points: "27.5 0 31 8 24 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle3",
    fill: "#C2E8FF",
    transform: "translate(27.500000, 51.000000) scale(1, -1) translate(-27.500000, -51.000000) ",
    points: "27.5 47 31 55 24 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle2",
    fill: "#C2E8FF",
    transform: "translate(51.000000, 27.500000) scale(1, -1) rotate(90.000000) translate(-51.000000, -27.500000) ",
    points: "51 23.5 54.5 31.5 47.5 31.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle1",
    fill: "#C2E8FF",
    transform: "translate(4.000000, 27.500000) scale(-1, -1) rotate(90.000000) translate(-4.000000, -27.500000) ",
    points: "4 23.5 7.5 31.5 0.5 31.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "PointerLight",
    fill: "#C2E8FF",
    transform: "translate(39.185544, 39.539543) scale(1, -1) rotate(45.000000) translate(-39.185544, -39.539543) ",
    points: "39.1855436 23.741378 48.2111846 55.3377083 30.1599026 55.3377083"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CompassDarkBlue",
    fill: "#8CD3F8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "PointerDark",
    transform: "translate(17.843564, 17.697564) scale(-1, 1) rotate(45.000000) translate(-17.843564, -17.697564) ",
    points: "17.8435642 1.89939863 26.8692052 33.4957289 8.81792318 33.4957289"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ScrewBkgd",
    cx: 29,
    cy: 29.0009383,
    rx: 4.5,
    ry: 4.50093828
  })), /*#__PURE__*/React.createElement("g", {
    id: "CompassWhite",
    transform: "translate(24.500000, 24.500000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Screw",
    cx: 4.5,
    cy: 4.50093828,
    rx: 4.5,
    ry: 4.50093828
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree2",
    transform: "translate(220.000000, 127.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree2LightBlue",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4209988,4.29236217 L16.259296,24.443436 C16.5666778,25.5043744 15.9557995,26.613617 14.8948612,26.9209988 C14.7139843,26.9734036 14.5266126,27 14.3382972,27 L2.6617028,27 C1.5571333,27 0.661702805,26.1045695 0.661702805,25 C0.661702805,24.8116846 0.688299176,24.6243129 0.74070397,24.443436 L6.57900117,4.29236217 C6.88638297,3.23142381 7.99562563,2.62054553 9.05656399,2.92792733 C9.71521023,3.11875451 10.2301717,3.63371594 10.4209988,4.29236217 Z",
    id: "Tree2LightBluebkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree2DarkBlue",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree2DarkBlueOutline1",
    strokeLinejoin: "round",
    points: "8.5 0.161971831 17 27 -1.8172e-12 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,3.16197183 C8.5,23.6275866 8.5,34.073596 8.5,34.5 C8.5,34.073596 8.5,23.6275866 8.5,3.16197183 Z",
    id: "Tree2DarkBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,14.6619718 C11.1666667,17.8925806 12.5,19.5592472 12.5,19.6619718 C12.5,19.5592472 11.1666667,17.8925806 8.5,14.6619718 Z",
    id: "Tree2DarkBlueLine1",
    strokeLinejoin: "round",
    transform: "translate(10.500000, 17.161972) scale(-1, 1) translate(-10.500000, -17.161972) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree1",
    transform: "translate(196.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree1LightBlue",
    transform: "translate(0.500000, 0.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8239437,0 L25.0758365,41.9391718 C25.3855734,42.9994249 24.7771597,44.1100213 23.7169065,44.4197582 C23.5347184,44.4729817 23.3458815,44.5 23.1560783,44.5 L2.49180902,44.5 C1.38723952,44.5 0.491809024,43.6045695 0.491809024,42.5 C0.491809024,42.3101968 0.518827286,42.1213599 0.572050791,41.9391718 L12.8239437,0 L12.8239437,0 Z",
    id: "Tree1LightBlueBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree1DarkBlue",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree1DarkBlueOutine",
    strokeLinejoin: "round",
    points: "13.5 0 26.5 43.5 0.5 43.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,3 C13.5,32.2486474 13.5,47.2486474 13.5,48 C13.5,47.2486474 13.5,32.2486474 13.5,3 Z",
    id: "Tree1DarkBlueLine3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82394366,19 C11.8239437,21.8726794 13.3239437,23.3726794 13.3239437,23.5 C13.3239437,23.3726794 11.8239437,21.8726794 8.82394366,19 Z",
    id: "Tree1DarkBlueLine2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8239437,34 C18.4906103,28.539346 20.8239437,25.8726794 20.8239437,26 C20.8239437,25.8726794 18.4906103,28.539346 13.8239437,34 Z",
    id: "Tree1DarkBlueLine1",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree3",
    transform: "translate(89.750000, 127.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree3LightBlue",
    transform: "translate(1.000000, 0.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4209988,4.29236217 L16.259296,24.443436 C16.5666778,25.5043744 15.9557995,26.613617 14.8948612,26.9209988 C14.7139843,26.9734036 14.5266126,27 14.3382972,27 L2.6617028,27 C1.5571333,27 0.661702805,26.1045695 0.661702805,25 C0.661702805,24.8116846 0.688299176,24.6243129 0.74070397,24.443436 L6.57900117,4.29236217 C6.88638297,3.23142381 7.99562563,2.62054553 9.05656399,2.92792733 C9.71521023,3.11875451 10.2301717,3.63371594 10.4209988,4.29236217 Z",
    id: "Tree3LightBluebkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree3DarkBlue",
    stroke: "#8CD3F8",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree3DarkBlueOutline1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "9.75 0.161971831 18.75 27 0.75 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,2.75 C9.75,21.6569293 9.75,31.323596 9.75,31.75 C9.75,31.323596 9.75,21.6569293 9.75,2.75 Z",
    id: "Tree3DarkBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2114258,17.1619718 L14.5,22.7269287 L10.2114258,17.1619718 Z",
    id: "Tree3DarkBlueLine1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(12.355713, 19.944450) scale(-1, 1) translate(-12.355713, -19.944450) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Birds",
    transform: "translate(64.500000, 104.500000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "BirdsLightBlue",
    transform: "translate(13.924449, 15.010733) rotate(-15.000000) translate(-13.924449, -15.010733) translate(2.924449, 2.510733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.869889675,1.74716683 C0.869889675,1.74716683 5.64196848,0.365470398 6.67627554,5.37495701",
    id: "BirdsLine4",
    transform: "translate(3.773083, 3.473744) rotate(41.000000) translate(-3.773083, -3.473744) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56595444,5.1193927 C5.56595444,5.1193927 10.3380332,3.73769627 11.3723403,8.74718288",
    id: "BirdsLine3",
    transform: "translate(8.469147, 6.845970) scale(-1, 1) rotate(-41.000000) translate(-8.469147, -6.845970) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86514239,21.2932757 C9.86514239,21.2932757 14.6372212,19.9115793 15.6715283,24.9210659",
    id: "BirdsLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8651424,21.2932757 C15.8651424,21.2932757 20.6372212,19.9115793 21.6715283,24.9210659",
    id: "BirdsLine1",
    transform: "translate(18.768335, 23.019853) scale(-1, 1) translate(-18.768335, -23.019853) "
  })))))))));
};
export default SvgSetupSmall;